/*
  feature-bar.js — turns the mobile feature bar into a swipeable carousel.
  On desktop the section is a static grid (the dots are hidden there);
  on mobile (<=749px) the items become a scroll-snap carousel and the dots
  reflect / control the active slide. All motion respects prefers-reduced-motion.

  Scrolling is animated manually with requestAnimationFrame rather than the
  native `behavior: 'smooth'` so it behaves consistently across environments.
*/
(function () {
  function animateScrollLeft(el, to, reduce) {
    var max = el.scrollWidth - el.clientWidth;
    var target = Math.max(0, Math.min(to, max));
    if (reduce) {
      el.scrollLeft = target;
      return;
    }
    var start = el.scrollLeft;
    var change = target - start;
    if (Math.abs(change) < 1) return;
    var duration = 350;
    var startTime = null;
    function step(timestamp) {
      if (startTime === null) startTime = timestamp;
      var t = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
      el.scrollLeft = start + change * eased;
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initFeatureBar(root) {
    if (!root || root.dataset.fbInit === 'true') return;

    var track = root.querySelector('.feature-bar__inner');
    var items = Array.prototype.slice.call(root.querySelectorAll('.feature-bar__item'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.feature-bar__dot'));
    if (!track || dots.length === 0) return;

    root.dataset.fbInit = 'true';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    // Click a dot to centre the matching feature in the carousel.
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var target = items[i];
        if (!target) return;
        var trackBox = track.getBoundingClientRect();
        var itemBox = target.getBoundingClientRect();
        var delta = itemBox.left + itemBox.width / 2 - (trackBox.left + trackBox.width / 2);
        animateScrollLeft(track, track.scrollLeft + delta, reduceMotion.matches);
      });
    });

    // Reflect the most-visible feature in the active dot while swiping.
    // (Dots are hidden on desktop, so toggling there is harmless.)
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          var best = null;
          entries.forEach(function (entry) {
            if (entry.isIntersecting && (!best || entry.intersectionRatio > best.intersectionRatio)) {
              best = entry;
            }
          });
          if (best) setActive(items.indexOf(best.target));
        },
        { root: track, threshold: [0.25, 0.5, 0.75, 1] }
      );
      items.forEach(function (item) {
        observer.observe(item);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.feature-bar').forEach(initFeatureBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-initialise when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector ? event.target.querySelector('.feature-bar') : null;
    if (section) initFeatureBar(section);
  });
})();
